import { Tooltip, Typography, Badge } from '@mui/material';
import {
  FilterPanelTrigger,
  useGridApiContext,
  gridFilterModelSelector,
  useGridSelector,
} from '@mui/x-data-grid-premium';
import FilterListIcon from '@mui/icons-material/FilterList';
import { FC } from 'react';
import { TextButton } from '../Button';
import { useSharedTFunction } from '@shared/i18n';

export interface CustomFilterButtonProps {
  activeFilterCount?: number;
}

export const CustomFilterButton: FC<CustomFilterButtonProps> = ({ activeFilterCount }) => {
  const t = useSharedTFunction();
  const apiRef = useGridApiContext();
  const filterModel = useGridSelector(apiRef, gridFilterModelSelector);

  const gridFilterCount = filterModel.items?.length ?? 0;
  const count = activeFilterCount ?? gridFilterCount;
  const hasItems = count > 0;

  return (
    <Tooltip title={t('shared.table.filter')}>
      <FilterPanelTrigger render={<TextButton color="primary" />}>
        <Badge badgeContent={hasItems ? count : null} color="primary">
          <FilterListIcon fontSize="small" color="primary" />
        </Badge>
        <Typography variant="body2">{t('shared.table.filter')}</Typography>
      </FilterPanelTrigger>
    </Tooltip>
  );
};
